// extracted by mini-css-extract-plugin
export var footer = "page-layout-module--footer--88767";
export var header = "page-layout-module--header--ba57e";
export var navigation = "page-layout-module--navigation--6bcdb";
export var page = "page-layout-module--page--21056";